import moment from 'moment';
import 'moment/locale/en-au';
moment.locale('en-au');

function parseDateTime(dateTime, formatString = null, inputIsUtc = true, outputAsUtc = false) {
    if (!dateTime) return null;
    var dateTimeMoment = formatString ? inputIsUtc ? moment.utc(dateTime, formatString) : moment(dateTime, formatString) : inputIsUtc ? moment.utc(dateTime) : moment(dateTime);
    if (!dateTimeMoment.isValid()) return null;
    return outputAsUtc ? dateTimeMoment.utc().toDate() : dateTimeMoment.local().toDate();
}

function formatDateTime(dateTime, formatString, inputIsUtc = true, outputAsUtc = false) {
    if (!dateTime) return null;
    var dateTimeMoment = inputIsUtc ? moment.utc(dateTime) : moment(dateTime);
    if (!dateTimeMoment.isValid()) return null;
    var dateTimeString = outputAsUtc ? dateTimeMoment.utc().format(formatString) : dateTimeMoment.local().format(formatString);
    return dateTimeString;
}

function formatSecondsAsDuration(totalSeconds) {
    if (!totalSeconds && (totalSeconds !== 0)) return null;
    var seconds = totalSeconds % 60;
    var totalMinutes = (totalSeconds - seconds) / 60;
    var minutes = totalMinutes % 60;
    var hours = (totalMinutes - minutes) / 60;
    var duration = '' + hours + ':';
    if (minutes < 10) duration = duration + '0';
    duration = duration + minutes;
    duration = duration + ':';
    if (seconds < 10) duration = duration + '0';
    duration = duration + seconds;
    return duration;
}

function getDayOfWeek(dateTime) {
    if(!dateTime) return null;
    return moment(dateTime).isoWeekday();
}

export default {
    filters: {
        parseDateTime: function (value, formatString = null, inputIsUtc = true, outputAsUtc = false) {
            return parseDateTime(value, formatString, inputIsUtc, outputAsUtc);
        },
        formatDateTime: function (value, formatString, inputIsUtc = true, outputAsUtc = false) {
            return formatDateTime(value, formatString, inputIsUtc, outputAsUtc);
        },
        formatSecondsAsDuration: function (totalSeconds) {
            return formatSecondsAsDuration(totalSeconds);
        },
        getDayOfWeek: function (value) {
            return getDayOfWeek(value);
        }
    },
    methods: {
        now() {
            return moment().toDate();
        },
        utcNow() {
            return moment().utc().toDate();
        },
        weekStart(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "weeks");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "weeks");
                }
            }
            return dateTime.startOf("isoWeek").toDate();
        },
        weekEnd(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "weeks");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "weeks");
                }
            }
            return dateTime.endOf("isoWeek").toDate();
        },
        monthStart(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "months");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "months");
                }
            }
            return dateTime.startOf("month").toDate();
        },
        monthEnd(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "months");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "months");
                }
            }
            return dateTime.endOf("month").toDate();
        },
        quarterStart(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "quarters");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "quarters");
                }
            }
            return dateTime.startOf("quarter").toDate();
        },
        quarterEnd(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "quarters");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "quarters");
                }
            }
            return dateTime.endOf("quarter").toDate();
        },
        yearStart(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "years");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "years");
                }
            }
            return dateTime.startOf("year").toDate();
        },
        yearEnd(unitsToAddOrSubtract) {
            var dateTime = moment();
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTime = dateTime.add(unitsToAddOrSubtract, "years");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTime = dateTime.subtract((unitsToAddOrSubtract * -1), "years");
                }
            }
            return dateTime.endOf("year").toDate();
        },
        addSeconds(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "seconds");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "seconds");
                }
            }
            return dateTimeMoment.toDate();
        },
        addMinutes(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "minutes");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "minutes");
                }
            }
            return dateTimeMoment.toDate();
        },
        addHours(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "hours");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "hours");
                }
            }
            return dateTimeMoment.toDate();
        },
        addDays(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "days");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "days");
                }
            }
            return dateTimeMoment.toDate();
        },
        addWeeks(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "weeks");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "weeks");
                }
            }
            return dateTimeMoment.toDate();
        },
        addMonths(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "months");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "months");
                }
            }
            return dateTimeMoment.toDate();
        },
        addYears(dateTime, unitsToAddOrSubtract) {
            var dateTimeMoment = moment(dateTime);
            if (unitsToAddOrSubtract) {
                if (unitsToAddOrSubtract > 0) {
                    dateTimeMoment = dateTimeMoment.add(unitsToAddOrSubtract, "years");
                } else if (unitsToAddOrSubtract < 0) {
                    dateTimeMoment = dateTimeMoment.subtract((unitsToAddOrSubtract * -1), "years");
                }
            }
            return dateTimeMoment.toDate();
        },
        parseDateTime: parseDateTime,
        formatDateTime: formatDateTime,
        setTimeComponent(dateTime, dateTimeForTimeComponent) {
            var dateTimeMoment = moment(dateTime);
            var dateTimeForTimeComponentMoment = moment(dateTimeForTimeComponent);
            dateTimeMoment.hour(dateTimeForTimeComponentMoment.hour());
            dateTimeMoment.minute(dateTimeForTimeComponentMoment.minute());
            dateTimeMoment.second(dateTimeForTimeComponentMoment.second());
            dateTimeMoment.millisecond(0);
            return dateTimeMoment.toDate();
        },
        setTimeComponents(dateTime, hour, minute = 0, second = 0) {
            var dateTimeMoment = moment(dateTime);
            dateTimeMoment.hour(hour);
            dateTimeMoment.minute(minute);
            dateTimeMoment.second(second);
            dateTimeMoment.millisecond(0);
            return dateTimeMoment.toDate();
        },
        setDateComponent(dateTime, dateTimeForDateComponent) {
            var dateTimeMoment = moment(dateTime);
            var dateTimeForDateComponentMoment = moment(dateTimeForDateComponent);
            dateTimeMoment.year(dateTimeForDateComponentMoment.year());
            dateTimeMoment.month(dateTimeForDateComponentMoment.month());
            dateTimeMoment.date(dateTimeForDateComponentMoment.date());
            return dateTimeMoment.toDate();
        },
        setDateComponents(dateTime, year, month, day) {
            var dateTimeMoment = moment(dateTime);
            dateTimeMoment.year(year);
            dateTimeMoment.month(month);
            dateTimeMoment.date(day);
            return dateTimeMoment.toDate();
        },
        formatSecondsAsDuration: formatSecondsAsDuration,
        getDifferenceInMinutes(startDateTime, endDateTime) {
            var startDateTimeMoment = moment(startDateTime);
            var endDateTimeMoment = moment(endDateTime);
            return endDateTimeMoment.diff(startDateTimeMoment, 'minutes');
        },
        getDayOfWeek: getDayOfWeek,
    }
}